import { useState } from "react";
import { Row, Card, CardBody, Col } from "shards-react";
import AuthForm from "./auth-form/AuthForm";
import AuthService from "../../services/auth-service/AuthService";
import Validate from "../../services/validate-service/Validate";
import AlertMessages from "../../utils/AlertMessages";
import logo_card from "../../images/eitri_logo.png";
import { useNavigate } from "react-router-dom";
import { AuthContainer, CustomizedAlert } from "./styles";
import Storage from "../../services/storage-service/Storage";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [hasError, setHasError] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const [msgError, setMsgError] = useState("");
    const navigate = useNavigate();

    const informations = { isFetching, hasError, msgError, src: logo_card };

    const infoFirstInput = {
        type: "text",
        label: "Email",
        name: "email",
        value: email,
        valid: Validate.emailValidate(email)
    };

    const infoSecondtInput = {
        type: "password",
        label: "Senha",
        name: "password",
        value: password,
        valid: password ? true : false
    };

    const handleChange = event => {
        event.preventDefault();
        const target = event.target;
        if (target.name === "email") {
            setEmail(target.value);
        }
        if (target.name === "password") {
            setPassword(target.value);
        }
    };

    const checkEmail = event => {
        event.preventDefault();

        if (!email) {
            console.debug("o valor do atributo email: ", email);
            return false;
        }
        return true;
    };

    const configButton = {
        theme: "primary",
        label: "Entrar"
    };

    const redirectAfterLogin = () => {
        let navigateToPage = "/select-organization";

        const cliLoginParams = Storage.getInSession(
            Storage.KEYS.CLI_LOGIN_PARAMS
        );
        if (cliLoginParams) {
            navigateToPage = "/settings/cli-generate-credential";
        }

        const loginTypeParams = Storage.getInSession(
            Storage.KEYS.CREDENTIAL_LOGIN_TYPE
        );
        if (loginTypeParams) {
            navigateToPage = "/settings/generate-credential";
        }
        navigate(navigateToPage);
    };

    const doLogin = e => {
        e.preventDefault();

        const emailIsValid = checkEmail(e);
        if (!emailIsValid || !Validate.emailValidate(email)) {
            setHasError(true);
            setMsgError("Ops! Insira um e-mail válido para continuar.");
            return;
        }

        setIsFetching(true);
        setHasError(false);
        if (Validate.emailValidate(email) && password) {
            setIsFetching(true);
            AuthService.basicAuth(email, password)
                .then(isAuth => {
                    setIsFetching(false);
                    setHasError(!isAuth);
                    const firstLogin = AuthService.isFirstLogin();
                    if (firstLogin) {
                        navigate("/reset_password", {
                            state: { email: email }
                        });
                    } else {
                        redirectAfterLogin();
                    }
                })
                .catch(error => {
                    console.log(error);
                    setIsFetching(false);
                    setHasError(true);
                    setMsgError(
                        AlertMessages.messageOnLogin(error.response?.status)
                    );
                });
        } else {
            setHasError(true);
            setMsgError(AlertMessages.messageOnLogin());
        }
    };
    return (
        <AuthContainer id="login-container">
            <Row>
                <Col sm="12">
                    {hasError ? (
                        <CustomizedAlert theme="danger">
                            {msgError}
                        </CustomizedAlert>
                    ) : null}
                </Col>
            </Row>
            <div className="form-auth--container">
                <Card>
                    <CardBody>
                        <Row style={{ marginBottom: 20 }}>
                            <Col className="form-auth--box">
                                <img
                                    className="user-avatar form-auth--width-image"
                                    src={informations.src}
                                    alt="Eitri Avatar"
                                />
                            </Col>
                        </Row>
                        <h4>
                            <strong>Portal de Eitri-Apps</strong>
                        </h4>
                        {!isFetching ? (
                            <AuthForm
                                screen="password"
                                informations={informations}
                                showBrand={false}
                                configFirstInput={infoFirstInput}
                                configSecondInput={infoSecondtInput}
                                configButton={configButton}
                                message="Conectando..."
                                actions={{
                                    formSubmit: doLogin,
                                    onchange: handleChange
                                }}
                            />
                        ) : (
                            <h5>Autenticando...</h5>
                        )}
                    </CardBody>
                </Card>
            </div>
        </AuthContainer>
    );
};

export default Login;
